"use client";

import React, { useState } from "react";
import Modal from "@litonarefin/components/Modal";
import { ContactFormForDocs } from "@litonarefin/components/ContactFormForDocs";

/**
 * "Get in touch!" link + its modal. Client-only because the modal is open/close
 * state; keeping it out of DocFooter lets the footer render on the server.
 */
function DocContactTrigger() {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <span
        className="jlt-text-[--primary] jlt-cursor-pointer"
        onClick={() => setIsOpenModal(true)}
      >
        Get in touch!
      </span>

      {isOpenModal ? (
        <Modal onCloseModal={() => setIsOpenModal(false)} width="auto" height="auto">
          <ContactFormForDocs />
        </Modal>
      ) : null}
    </>
  );
}

export default DocContactTrigger;
